import { ActionType, getType } from 'typesafe-actions';

import * as currentOrder from '../../../actionCreators/currentOrder';
import { actions as fetchMember } from '../../../actionCreators/flows/fetchMember';

import processMobileNumber from '../../../utils/processors/processMobileNumber';

const initialState = null;

export default function (
  state: string | null = initialState,
  action: ActionType<typeof currentOrder> | ActionType<typeof fetchMember>,
): string | null {
  switch (action.type) {
    case getType(currentOrder.setPurchaser): {
      const { value } = action.payload;
      return processMobileNumber(value.mobile);
    }
    case getType(currentOrder.setPurchaserMobile): {
      const { value } = action.payload;

      return processMobileNumber(value);
    }
    case getType(currentOrder.adjustPurchaserMobile): {
      const { value } = action.payload;

      switch (value) {
        case 'clear': {
          return initialState;
        }
        case 'delete': {
          return (state || '').slice(0, -1);
        }
        default:
          return `${state || ''}${value}`.trimLeft();
      }
    }
    default:
      return state;
  }
}
